module.exports = __webpack_public_path__ + "static/media/covid-19-isolation-tips-news.693ab421.jpg";